import { useEffect } from 'react';
import { useNetSessionStore } from '../../store/netSessionSlice';
import { useGameStore } from '../../store/gameSlice';

/**
 * Persistent co-op session badge: shows the current party (code + player count)
 * while in a session, hidden while an interface overlay is open and restored
 * when it closes. Also surfaces transient net notices (e.g. host disconnected),
 * which auto-clear.
 */
export const SessionHud = () => {
  const role = useNetSessionStore((s) => s.role);
  const code = useNetSessionStore((s) => s.code);
  const playerCount = useNetSessionStore((s) => s.playerCount);
  const notice = useNetSessionStore((s) => s.notice);
  const setNotice = useNetSessionStore((s) => s.setNotice);
  const activeInterface = useGameStore((s) => s.activeInterface);

  useEffect(() => {
    if (!notice) {
      return;
    }
    const id = window.setTimeout(() => setNotice(null), 4000);
    return () => window.clearTimeout(id);
  }, [notice, setNotice]);

  const showBadge = role !== 'offline' && activeInterface === null;
  if (!showBadge && !notice) {
    return null;
  }

  return (
    <div style={hudStyle}>
      {showBadge && (
        <div style={badgeStyle}>
          Partie <strong>{code ?? '—'}</strong> · {playerCount} joueur
          {playerCount > 1 ? 's' : ''}
        </div>
      )}
      {notice && <div style={noticeStyle}>{notice}</div>}
    </div>
  );
};

const hudStyle: React.CSSProperties = {
  position: 'fixed',
  top: 12,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 10000,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 6,
  pointerEvents: 'none',
};

const badgeStyle: React.CSSProperties = {
  padding: '4px 12px',
  background: 'rgba(20,20,28,0.85)',
  color: '#fff',
  borderRadius: 999,
  font: '13px sans-serif',
};

const noticeStyle: React.CSSProperties = {
  padding: '6px 14px',
  background: 'rgba(60,20,24,0.92)',
  color: '#ffd9d9',
  borderRadius: 6,
  font: '13px sans-serif',
};
